import RestService from "./rest.service";

class ProfileService {
  profile() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getProfile(`app/profile`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  uploadFiles(file) {
    return new Promise((fnResolve, fnReject) => {
      let data = new FormData();
      for (let index = 0; index <= file.length - 1; index++) {
        data.append("file", file[index]);
      }
      // data.append("file", file);
      RestService.uploadFilesProfile(`app/profile/upload`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }



  updateUserLanguage(language) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/profile/language`, { language: language }).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new ProfileService();
